import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPigletManureStorage, setFootprintingPigletManureStorageAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_MANURE_STORAGE } from "consts";

import { FootprintingPigletManureStoragePayload } from "models";

export const useMutateFootprintingPigletManureStorage = (
  farmId: string,
  year: number,
  payload: FootprintingPigletManureStoragePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PIGLET_MANURE_STORAGE, primaryDataId, isAdmin],
      mutationFn: () =>
        isAdmin ? setFootprintingPigletManureStorageAdmin(payload, primaryDataId) : setFootprintingPigletManureStorage(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PIGLET_MANURE_STORAGE, primaryDataId, isAdmin],
          ...footprintingPigletPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
